
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","width":"700","height":"393.75"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"681","height":"144"}}),_c('g',{attrs:{"transform":"matrix(.76 0 0 .76 -10 -800)"}},[_c('linearGradient',{attrs:{"id":"SVGID_1_","gradientUnits":"userSpaceOnUse","x1":"8","y1":"945.5","x2":"1302","y2":"945.5"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#fc551f"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#ff2330"}})]),_c('linearGradient',{attrs:{"id":"SVGID_00000118386300857662075660000017500943838328931730_","gradientUnits":"userSpaceOnUse","x1":"20","y1":"829.5","x2":"701","y2":"829.5"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#c3eb11"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#c3eb11"}})]),_c('path',{attrs:{"transform":"scale(1.3)","fill":"url(#SVGID_00000118386300857662075660000017500943838328931730_)","d":"M701 788H48l-28 83h654z"}}),_v('/>'),_c('linearGradient',{attrs:{"id":"SVGID_00000013159891697529847460000005850570146978837146_","gradientUnits":"userSpaceOnUse","x1":"20","y1":"903.5","x2":"58","y2":"903.5"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#7d901b"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#7d901b"}})]),_c('path',{attrs:{"transform":"matrix(1.3 0 0 1.3 0 -1.3)","fill":"url(#SVGID_00000013159891697529847460000005850570146978837146_)","d":"M20 872h38l-19 63z"}})])])
          )
        }
      }
    